import { render, staticRenderFns } from "./EditPatientStory.vue?vue&type=template&id=707c68de"
import script from "./EditPatientStory.vue?vue&type=script&lang=js"
export * from "./EditPatientStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports